import { spellCollection } from '@/constants/spellList'
import generateTextLinks from '@/utils/generateTextLinks'

export default (spellId, preText = '', postText = '') => {
  const {name} = spellCollection[spellId]

  return generateTextLinks(`[${name}](SPELL:${spellId})${preText}${postText}`)
}

